import React from 'react';
import Link from 'gatsby-link';
import SiteHeaderNavigation from '../SiteNavigation';

import './site-header.css';

class SiteHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { scrolled: false };
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  };

  handleScroll = () => {
    const isScrolled = this.state.scrolled;

    // Add opacity class to site header
    if (document.documentElement.scrollTop > 0) {
      if (!isScrolled) {
        this.setState({ scrolled: true });
      }
    } else {
      this.setState({ scrolled: false });
    }
  };

  render() {
    const { scrolled } = this.state;
    const scrollClass = scrolled ? 'scrolled' : '';

    return (
      <header className={`site-head ${scrollClass}`}>
        <div className="site-head--wrap">
          <div className="site-head--title-wrap">
            <h1 className="site-head--title">
              <Link to="/">Jody Boucher</Link>
            </h1>
            <h2 className="site-head--description">Software Engineer</h2>
          </div>
          <SiteHeaderNavigation />
        </div>
      </header>
    );
  }
}

export default SiteHeader;



// WEBPACK FOOTER //
// ./src/components/SiteHeader/index.js